var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 22,
    viewBox: "0 0 11 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12435 5.50008V16.0417C9.12435 18.0676 7.48352 19.7084 5.45768 19.7084C3.43185 19.7084 1.79102 18.0676 1.79102 16.0417V4.58341C1.79102 3.31841 2.81768 2.29175 4.08268 2.29175C5.34768 2.29175 6.37435 3.31841 6.37435 4.58341V14.2084C6.37435 14.7126 5.96185 15.1251 5.45768 15.1251C4.95352 15.1251 4.54102 14.7126 4.54102 14.2084V5.50008H3.16602V14.2084C3.16602 15.4734 4.19268 16.5001 5.45768 16.5001C6.72268 16.5001 7.74935 15.4734 7.74935 14.2084V4.58341C7.74935 2.55758 6.10852 0.916748 4.08268 0.916748C2.05685 0.916748 0.416016 2.55758 0.416016 4.58341V16.0417C0.416016 18.8284 2.67102 21.0834 5.45768 21.0834C8.24435 21.0834 10.4993 18.8284 10.4993 16.0417V5.50008H9.12435Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.2955d91207fdb693322131482540f499.svg";
export { ForwardRef as ReactComponent };